import Vue from 'vue';
import VueRouter from 'vue-router';
// 引入轨迹回放核心组件 Track
import Track from './components/Track.vue';

// 注册VueRouter（必须调用Vue.use，否则路由无效）
Vue.use(VueRouter);

// 路由规则：访问根路径（/）时，渲染Track组件
const routes = [
    {
        path: '/', // 根路径
        name: 'TrackPlayback', // 路由名称（可选）
        component: Track // 对应加载的组件
    }
];

// 创建路由实例
const router = new VueRouter({
    mode: 'hash', // 路由模式（hash模式：URL带#，无需后端配置；history模式需后端配合）
    routes // 传入路由规则
});

export default router;